import { SubAPI } from "./SubAPI";
export class Contacts extends SubAPI {
    list(props) { return this.fetcher.get("/api/contacts", props); }
    upsert(input) { return this.fetcher.post("/api/contact", input); }
    get(props) { return this.fetcher.get("/api/contact", props); }
    setProjectLink(input) { return this.fetcher.post("/api/contact/set-project-link", input); }
}
